import React, { useMemo } from "react";
import { Summary } from "@companion-core/shared/app/Components/DynamicForm/Summary";
import { RequestSummaryProps } from "@companion-core/shared/app/Components/Requests/RequestDetail/RequestSummary/requestSummary.model";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { useRequestSummary } from "@companion-core/shared/app/Components/Requests/RequestDetail/RequestSummary/hooks/useRequestSummary";
import { APIProposal, APIRecommendation } from "@companion-core/shared/app/Interfaces/API";
import { Field } from "@companion-core/shared/app/Interfaces/wizard";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import { AddToCalendarButton } from "@companion-core/shared/app/Components/Requests/RequestDetail/AddToCalendarButton/AddToCalendarButton";
dayjs.extend(localizedFormat);
dayjs.extend(utc);

export const RequestSummary = ({
  requestData,
  proposalsData,
  summary,
  status,
  performCancelRequest,
  performUpdateRequest,
  performDisplayProposals,
  performDisplayRecommendationDetail,
}: RequestSummaryProps) => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const hasDigitalProposal = requestData?.has_digital_proposal;
  const proposalValidated = () => {
    return proposalsData?.data?.results?.find(
      (proposal: APIProposal) => proposal.status == "validated"
    );
  };
  const recommendationValidated = useMemo(() => {
    return proposalValidated()?.recommendations?.find(
      (recommendation: APIRecommendation) => recommendation.status == "validated"
    );
  }, [proposalsData]);

  const { RequestSummaryButtonContainer } = useRequestSummary({
    proposalId: proposalValidated()?.id,
    recommendationId: recommendationValidated?.id,
    performCancelRequest,
    performUpdateRequest,
    performDisplayProposals,
    performDisplayRecommendationDetail,
  });

  const location = useMemo(() => {
    return (
      recommendationValidated?.beginning_address?.formatted_address ??
      (summary.find((field: Field) => field.name == "location")?.summaryValue as string) ??
      (summary.find((field: Field) => field.name == "start_location")?.summaryValue as string)
    );
  }, [summary]);

  return (
    <div className="request-detail__summary">
      <Summary fieldList={summary} display={isMobileSize ? "mobile" : "desktop"} />
      {status === "booked" && isMobileSize && (
        <AddToCalendarButton requestData={requestData} location={location} />
      )}
      <div data-testid="request-detail__cta-container" className="request-detail__cta-container">
        <RequestSummaryButtonContainer status={status} hasDigitalProposal={hasDigitalProposal} />
      </div>
    </div>
  );
};
